/** The plan fields an order carries when a subscription made it (service-core OrderDto). */
export interface OrderPlanFields {
  planId?: string | null
  planName?: string | null
  /** Its place in the plan: 2 in "2 of 4". */
  planDeliveryNumber?: number | null
  /** The plan's number of deliveries; null when it runs until cancelled. */
  planTotalDeliveries?: number | null
}

/**
 * "Subscription · 2 of 4" for an order a subscription made, "Subscription"
 * when the plan runs until cancelled (or the number is unknown), and null for
 * any other order.
 */
export function subscriptionOrderLabel(order: OrderPlanFields | null | undefined): string | null {
  if (!order?.planId) return null
  const number = order.planDeliveryNumber
  const total = order.planTotalDeliveries
  if (total != null && total > 0 && number != null && number > 0) return `Subscription · ${number} of ${total}`
  return 'Subscription'
}
